import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation FlaggedAnswerResolve($uid: String!){
        answer_flag_resolve (uid: $uid) {
            success
        }
    }
`;

export async function flaggedAnswerResolve(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ answer_flag_resolve: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.answer_flag_resolve;
}
